import {PRODUCT_SYNC_SUCCESSFUL_MESSAGES} from '../constants';

const isSyncRegistryProductSuccessful = syncResult => {
  if (!syncResult) {
    return false;
  }
  return (
    syncResult.retailerItemsAPISyncResults ===
      PRODUCT_SYNC_SUCCESSFUL_MESSAGES[0] &&
    PRODUCT_SYNC_SUCCESSFUL_MESSAGES.includes(
      syncResult.retailerProductAPISyncResults,
    )
  );
};

export default isSyncRegistryProductSuccessful;
